import { useEffect, useRef, useState } from 'react';

import { pageBlocks } from './editor';
import type { LensDocument, LensDocumentData } from './types';

const LANDED_MS = 1400;
const NONE = new Set<string>();

function signatures(document: LensDocument, data: LensDocumentData) {
  return new Map(
    pageBlocks(document.page).map((block) => {
      const planned = data.blocks[block.id];
      return [block.id, JSON.stringify([block, planned?.queries ?? planned?.query ?? null])] as const;
    }),
  );
}

export default function useLandedBlocks(document: LensDocument, data: LensDocumentData | undefined, applying: boolean): Set<string> {
  const settled = useRef<{ version: number; blocks: Map<string, string> }>(undefined);
  const [landed, setLanded] = useState(NONE);
  useEffect(() => {
    if (!data || applying) return;
    const blocks = signatures(document, data);
    const before = settled.current;
    settled.current = { version: data.lensVersion, blocks };
    if (!before || before.version === data.lensVersion) return;
    const changed = [...blocks].filter(([id, signature]) => before.blocks.get(id) !== signature).map(([id]) => id);
    if (changed.length) setLanded(new Set(changed));
  }, [document, data, applying]);
  useEffect(() => {
    if (!landed.size) return undefined;
    const timer = setTimeout(() => setLanded(NONE), LANDED_MS);
    return () => clearTimeout(timer);
  }, [landed]);
  return landed;
}
